<template lang="pug">
	modal(:max-width="800")
		.card
			.card-header.bg-info
				span.fa.fa-list.mr-2
				| Bloques seleccionados
				button.close(@click="cerrar") &times;
			table.table.table-striped
				thead
					tr
						th ID bloque
						th Hora
						th Inserciones
						th Inserciones tot
						th Ocupación bloque
						th Restante bloque
				tbody
					tr(
						v-for="(bloque, i) in bloquesUsados"
						:key="i"
					)
						th {{ bloque.BloqueID}}
						th {{ bloque.HoraInicio }}
						th {{ bloque.Inserciones }}
						th {{ getInsercionesTotales(bloque) }}
						th {{ getOcupacion(bloque).porcentaje }} %
						th {{ getOcupacion(bloque).segundos }} s
</template>

<script>
export default {
	props: ['insercion', 'bloques'],
	computed: {
		bloquesUsados () {
			const bloques = this.insercion.Bloques.reduce((acc, bloque) => {
				if (acc.has(bloque.BloqueID)) {
					const b = acc.get(bloque.BloqueID)
					b.Inserciones = b.Inserciones + 1
					acc.set(bloque.BloqueID, b)
				} else {
					acc.set(bloque.BloqueID, {
						BloqueID: bloque.BloqueID,
						Inserciones: 1,
						HoraInicio: bloque.HoraInicio,
						Duracion: bloque.Duracion,
						DuracionInserciones: bloque.DuracionInserciones
					})
				}
				return acc
			}, new Map())

			return Array.from(bloques).map(b => b[1])
		}
	},
	methods: {
		getOcupacion (bloque) {
			const b = this.bloques.get(bloque.BloqueID)
			const total = bloque.Duracion
			let ocupado = bloque.DuracionInserciones + b.DuracionInsercionesNuevas

			return {
				porcentaje: this.$options.filters.round(ocupado * 100 / total, 2),
				segundos: total - ocupado
			}
		},
		getInsercionesTotales (bloque) {
			const BloqueID = bloque.BloqueID

			const b = this.bloques.get(BloqueID)
			return b.TotalInserciones + b.LineasInserciones.length
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/detalles-dia/resumen-bloques.component.vue